import React from "react";
import { IncomingCashsDetail } from "src/components/Pages/Documents/IncomingCashs/components/IncomingCashsDetail";
import IncomingCashsList from "src/components/Pages/Documents/IncomingCashs/components/IncomingCashsList";
import { CreateIncomingCashsDto } from "src/components/Pages/Documents/IncomingCashs/dtos/CreateIncomingCashsDto";
import { IncomingCashOperationTypeEnum } from "src/components/Pages/Documents/IncomingCashs/dtos/IncomingCashOperationTypeEnums";
import { NFLookupIncomingCashPayments } from "src/components/Shared/NewForms/NFLookupIncomingCashPayments";
import { IAppEntity } from "src/config/entities";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { IncomingCashPaymentService } from "src/services/documents/IncomingCashPaymentService";

export const IncomingCashPayments: IAppEntity = {
  entityType: "document",
  title: "Incoming Cashs",
  pluralTitle: "Incoming cash payments",
  apiUrl: "IncomingCashPayments",
  apiEnum: ReferenceTypes.DocumentIncomingCashPayment,
  getDetailView: (id?: string) => {
    return React.createElement(IncomingCashsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(IncomingCashsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupIncomingCashPayments, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new IncomingCashPaymentService("IncomingCashPayments"),
  getEmptyModel: () => {
    const model: CreateIncomingCashsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      operationType: IncomingCashOperationTypeEnum.customerPayment,
      createdDate: new Date(),
      processedDate: new Date(),
      documentDate: new Date(),
      payments: [], 
    };
    return model;
  },
};
